import { useQuery } from "@tanstack/react-query";
import OrganisationService from "../services/OrganisationService";

export const useOrganisationsQuery = () => {
  return useQuery({
    queryKey: ["organisations", "all"],
    queryFn: () => OrganisationService.getOrganisations({ pagination: false }),
    staleTime: 30 * 60 * 1000,
  });
};

// Linked asset owners change rarely, so a few minutes of cache is plenty.
// Invalidate the key family on contractor<->asset-owner link/unlink:
//   queryClient.invalidateQueries({ queryKey: ["organisations", id, "asset-owners"] });
// `search` is wired to the backend's case-insensitive substring filter rather
// than client-side filtering, per the endpoint spec.
// `initialData` seeds the unfiltered list (e.g. from /auth/me). It is marked stale
// (updatedAt 0) so the endpoint refetches in the background and stays authoritative.
export const useLinkedAssetOwnersQuery = (
  contractorId,
  search,
  { initialData } = {},
) => {
  const seed = !search && initialData ? initialData : undefined;
  return useQuery({
    queryKey: ["organisations", contractorId, "asset-owners", search || ""],
    queryFn: () =>
      OrganisationService.getLinkedAssetOwners(contractorId, { search }),
    enabled: !!contractorId,
    staleTime: 5 * 60 * 1000,
    placeholderData: (prev) => prev,
    initialData: seed,
    initialDataUpdatedAt: seed ? 0 : undefined,
  });
};
